import classNames from "classnames";
import React, { FunctionComponent } from "react";
import { ReactComponent as IconWarning } from "../../../../icons/warning.svg";
import "./style.scss";

interface Props {
  label?: string;
  type?: "inline" | "floating";
}

const LowQualityIndicator: FunctionComponent<Props> = ({ label, type = "inline" }) => {
  return (
    <span
      className={classNames("LowQualityIndicator", `LowQualityIndicator-${type}`, {
        "LowQualityIndicator-labelled": !!label,
      })}
      data-alert={label}
    >
      <IconWarning />
    </span>
  );
};

export default LowQualityIndicator;
